import {
  type RouteObject,
} from "react-router";
import TagDetailApp from "Tag/Detail/app";
import ListTagApp from "Tag/List/app";
import TagNewApp from "Tag/New/app";

declare let viewModel: any;

export const tagRoute: RouteObject = {
  path: "tag",
  children: [{
    path : ":mainArea",
    loader: () => viewModel,
    Component: ListTagApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: TagDetailApp,
  }, {
    path: ":mainArea/new",
    loader: () => viewModel,
    Component: TagNewApp,
  }]
};